module.exports = __webpack_public_path__ + "static/img/20200518-03.38dc569.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20200518-03.png
// module id = 19lS
// module chunks = 1